module.exports = __webpack_public_path__ + "static/media/vc-serious.1e1c953e.svg";